<h1 class="title">{{ isEdit ? 'Edit' : 'Add' }} Test Financial Account</h1>
<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

<form [formGroup]="bankForm">
  <div class="form-title">Financial Account Details</div>
  <rkt-form class="name-field" [form]="bankForm" [fields]="financialAccountFields" [model]="formModel"></rkt-form>
</form>

<form [formGroup]="bankForm">
  <div class="form-title">Banking Info</div>
  <rkt-form (modelChange)="onAccountNumberChange()" [form]="bankForm" [fields]="bankFields" [model]="formModel"></rkt-form>
</form>

<div class="account-balance-section">
  <div class="rkt-form">
    <div class="rkt-form-control">
      <div class="rkt-form-field">
        <div class="rkt-form-label">
          <label [id]="'account-balance'">Account Balance</label>
        </div>

        <div class="rkt-form-input-field">
          <input
            type="text"
            class="rkt-form-input"
            [formControl]="accountBalance"
            [id]="'account-balance-input'"
            mask="separator.2"
            decimalMarker="."
            [prefix]="accountBalance.value ? '$ ' : ''"
            thousandSeparator=","
            placeholder="$ 0.00"
            (blur)="onAmountFieldBlur()"
            [allowNegativeNumbers]="false"
            required
          />
        </div>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="bankForm">
  <rkt-form (modelChange)="onAccountNumberChange()" [form]="bankForm" [fields]="accountNumberFields" [model]="formModel"></rkt-form>
</form>

@if (formError) {
  <div class="details-page-edit-form-error">{{ formError }}</div>
}

<div class="buttons">
  <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
  <button
    rktButton
    type="submit"
    (click)="onSubmit()"
    [disabled]="formLoading || !bankForm.valid"
    [title]="(isEdit ? 'Update' : 'Add') + ' Mock Financial Account'"
  >
    {{ isEdit ? 'Update' : 'Add' }}
  </button>
</div>
